<script setup>
import LessonRow from "./LessonRow.vue";
import { TableContainer, TableHeader } from "@easy/ui/tables";
import { markRaw } from "vue";
import { useRouter } from "vue-router";
import { CardEmpty, CardPreloader } from "@easy/ui/cards";
import { MultipleFileIcon } from "@easy/ui/icons";
import { PLAYER_ROUTE_NAMES } from "@/apps/player/player.routes";

defineProps({
    lessons: {
        type: Array,
        default: () => [],
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
    searchQuery: {
        type: String,
        default: "",
    },
});

const emptyIcon = markRaw(MultipleFileIcon);
const router = useRouter();

const createFile = () => {
    router.push({ name: PLAYER_ROUTE_NAMES.projectFiles, query: { open: "create" } });
};
</script>

<template>
    <div class="py-5 sm:p-6 space-y-6">
        <CardPreloader v-if="isLoading" />
        <CardEmpty
            v-else-if="!isLoading && !lessons?.length"
            class="w-full ct-bg-1"
            :title="
                searchQuery
                    ? $t('player.empty.title_when_search', { query: searchQuery })
                    : $t('player.empty.title')
            "
            :icon="emptyIcon"
            :ctaLabel="searchQuery ? '' : $t('player.empty.cta')"
            @add="createFile"
        />
        <TableContainer v-else>
            <template #headers>
                <tr>
                    <TableHeader> {{ $t("shared.name") }} </TableHeader>
                    <TableHeader sm-hidden> {{ $t("player.panel.lessons.finished") }}</TableHeader>
                    <TableHeader sm-hidden>{{ $t("player.panel.lessons.progress") }}</TableHeader>
                    <TableHeader sm-hidden> {{ $t("player.panel.lessons.link") }}</TableHeader>
                </tr>
            </template>

            <template #body>
                <LessonRow :file="lesson" v-for="lesson in lessons" :key="lesson.id" />
            </template>
        </TableContainer>
    </div>
</template>
